import { render, staticRenderFns } from "./ModelLinkSummary.vue?vue&type=template&id=b441bc3e&scoped=true"
import script from "./ModelLinkSummary.vue?vue&type=script&lang=ts"
export * from "./ModelLinkSummary.vue?vue&type=script&lang=ts"
import style0 from "./ModelLinkSummary.vue?vue&type=style&index=0&id=b441bc3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b441bc3e",
  null
  
)

export default component.exports